<template>
  <div class="solution-details-view">
    <Header />
    
    <div class="solution-details-container">
      <SolutionDetails />
    </div>
    
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import SolutionDetails from '@/components/solution_details/SolutionDetails.vue';

export default {
  name: 'SolutionDetailsView',
  components: {
    Header,
    Footer,
    SolutionDetails
  }
};
</script>

<style scoped>
.solution-details-view {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #f9faf5;
}

.solution-details-container {
  flex: 1;
  width: 100%;
  margin-top: 80px;
  padding-bottom: 3rem;
}

@media (max-width: 768px) {
  .solution-details-container {
    margin-top: 60px;
  }
}
</style>